/* eslint-disable */

export const AddressUtils = {

    parseAddressString(value) {
        const address = value.split(", ");
        const street = address[0].split(" ");
        if (address.length < 3 || street.length < 2) {
            return {
                city: null,
                postcode: null,
                streetNumber: null,
                street: null,
            };
        }
        if (address.length === 4) {
            return {
                city: address[3].trim(),
                postcode: address[2].trim(),
                streetNumber: address[1].trim(),
                street: address[0].trim(),
            };
        }
        return {
            city: address[2].trim(),
            postcode: address[1].trim(),
            streetNumber: street.pop().trim(),
            street: street.join(" ").trim(),
        };
    },

    getAddressDetail(address, name) {
        if (address) {
            const fields = address.filter((obj) => obj.types.includes(name));
            if (fields.length > 0) return fields[0].long_name;
        }
        return "";
    },

    getSubpremise(address, tryToMatch) {
        let subpremise = this.getAddressDetail(address, "subpremise");
        if (subpremise) return subpremise;
        if (tryToMatch) {
            const regex = /\/([^,]*),/mg;
            subpremise = document.getElementById("address-autocomplete").childNodes[0].value.match(regex);
            if (subpremise) return subpremise[0].slice(1, -1);
        }
    return undefined;
    },

    parseAddressComponents(address) {
        const streetNumber = this.getAddressDetail(address, "street_number");
        const street = this.getAddressDetail(address, "route");
        const subpremises = this.getSubpremise(address, !!streetNumber);
        const city = this.getAddressDetail(address, "locality");
        const postcode = this.getAddressDetail(address, "postal_code");
        return {
            streetNumber, street, subpremises, city, postcode
        }
    }
}
